import db from './db-alop.json'

const index = {}
const walkNode = (node, fn, ancestry = []) => {
  fn(node, ancestry)

  if (node.children) {
    for (const child of node.children) {
      walkNode(child, fn, ancestry.concat([node]))
    }
  }
}

walkNode(db, node => {
  if (node.data && node.data.id) {
    index[node.data.id] = node
  }
})

export const walk = (fn) => walkNode(db, fn)
export const get = id => index[id] ? index[id].data : index[id]
export const units = db.children.map(x => ({ id: x.id, name: x.name }))